import React, {Fragment} from "react";
import {Button, Col, Divider, Dropdown, Menu, notification, Popconfirm, Space, Typography} from "antd";
import {MoreOutlined, PlusOutlined} from "@ant-design/icons";
import {checkForfait, checkPermissions} from "../../../../components/permissions/functions";
import ContactIcon from "../../../../components/util-components/ContactIcon";
import IntlMessage from "../../../../components/util-components/IntlMessage";
import ApiService from "../../../../services/ApiService";

const {Text, Title} = Typography

export class FicheRappel extends React.Component {

    async onDeleteRappel(id) {
        if (!checkPermissions(["contact.edit"]) || !checkForfait(["CRM", "COM", "FULL"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }

        const selected = this.props.selected

        await ApiService.post("/contact/rappel/hazkara/"+selected.id+"/delete/" + id)
        await this.props.fiche.getData()

        notification.success({
            message: <IntlMessage id="success.delete"/>
        })
    }

    render() {
        const {selected, fiche} = this.props

        if (!selected || !selected.deceased) {
            return null
        }

        return (
            <Col>
                <Col style={{display: "flex", justifyContent: "flex-end", marginBottom: 20}}>
                    <Button type="primary" icon={<PlusOutlined/>} onClick={() => fiche.modalHazkara.show(selected.id)}>
                        Ajouter un rappel contact</Button>
                </Col>
                {
                    [...selected.rappels].map((item, index) => {
                        var contact = selected.rappelContacts.find(i => i.id === item.contact)
                        if (!contact) {
                            return null
                        }

                        let familyLinks=selected.familyLinks.filter(i => i.contact === contact.id)

                        return (
                            <Fragment>
                                <Space size="small">

                                    <Dropdown overlay={
                                        <Menu
                                            items={[
                                                {
                                                    label: (
                                                        <a onClick={() =>fiche.modalHazkara.show(selected.id,item)}>Modifier</a>
                                                    ),
                                                    key: "1",
                                                },
                                                {
                                                    label: (
                                                        <Popconfirm
                                                            title="Êtes-vous sûrs de vouloir supprimer ce rappel de décés ?"
                                                            onConfirm={() => this.onDeleteRappel(item.id)}
                                                            okText="Oui"
                                                            cancelText="Non"
                                                            okType={"danger"}
                                                        >
                                                            <Text type={"danger"}>Supprimer</Text>
                                                        </Popconfirm>
                                                    ),
                                                    key: "2",
                                                }
                                            ]}
                                        />
                                    } trigger={['click']}>
                                        <MoreOutlined/>
                                    </Dropdown>

                                    <Button icon={<ContactIcon contact={contact}/>} type="link" onClick={() => fiche.modalContact.show(item.contact)}>{contact.nom} {contact.prenom}</Button>

                                    {familyLinks.map(i=>fiche.formatFamilyLink(i.type, contact.homme))}
                                </Space>

                                {selected.rappels.length > 1 && index < selected.rappels.length - 1 && (
                                    <Divider/>
                                )}
                            </Fragment>
                        )
                    })
                }
            </Col>
        )
    }
}
